import React, { forwardRef, memo } from 'react'

const TicketPrimaryIcon = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width="29.4"
    height="29.4"
    viewBox="0 0 42 42"
    fill="none"
    {...props}>
    <path
      d="M16.1736 9.74512V32.7043"
      stroke="#78BE20"
      strokeWidth="3.22689"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.69385 26.3267C6.04699 26.3267 7.34472 25.7892 8.30154 24.8324C9.25835 23.8756 9.79589 22.5779 9.79589 21.2247C9.79589 19.8716 9.25835 18.5738 8.30154 17.617C7.34472 16.6602 6.04699 16.1227 4.69385 16.1227V11.0206C4.69385 10.6823 4.82823 10.3579 5.06744 10.1187C5.30664 9.8795 5.63107 9.74512 5.96936 9.74512H36.5816C36.9199 9.74512 37.2443 9.8795 37.4835 10.1187C37.7227 10.3579 37.8571 10.6823 37.8571 11.0206V16.1227C36.504 16.1227 35.2062 16.6602 34.2494 17.617C33.2926 18.5738 32.7551 19.8716 32.7551 21.2247C32.7551 22.5779 33.2926 23.8756 34.2494 24.8324C35.2062 25.7892 36.504 26.3267 37.8571 26.3267V31.4288C37.8571 31.7671 37.7227 32.0915 37.4835 32.3307C37.2443 32.5699 36.9199 32.7043 36.5816 32.7043H5.96936C5.63107 32.7043 5.30664 32.5699 5.06744 32.3307C4.82823 32.0915 4.69385 31.7671 4.69385 31.4288V26.3267Z"
      stroke="#78BE20"
      strokeWidth="3.22689"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))

TicketPrimaryIcon.displayName = 'TicketPrimaryIcon'

export default memo(TicketPrimaryIcon)
